export default __webpack_public_path__ + "static/media/PrivacyPolicyTemplate.bfb928a2.md";